<template>
  <div>
    <img v-if="heroImage" class="pet-photo" :src="heroImage.thumbnails.small" width="100" :alt="pet.name">
    <img v-else class="pet-photo" src="../../assets/Images/DogProfile_Blue_300.svg" width="100" alt="DefaultPetImage"/>
  </div>
</template>

<script>
import { PetImagesCacheMixin } from '@/mixins/Booking/PetImagesCacheMixin'

export default {
  name: 'PetProfileImage',
  mixins: [PetImagesCacheMixin],
  props: {
    pet: Object
  },
  computed: {
    petId () {
      return this.pet?.id || ''
    },
    heroImage () {
      return this.petImages?.find(pi => pi.ownerId === this.petId) ?? null
    }
  }
}
</script>
